// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';
import {getAppConfig} from '../repositories';

export const setAppConfig = async store => {

    try {

        const data = await getAppConfig();

        store.dispatch({
            data,
            type: actions.READ_APP_CONFIG_SUCCESS
        });

    } catch (error) {

    }

};



// WEBPACK FOOTER //
// ./src/app-config/action-creators/app-config.js